import { Component, OnInit } from '@angular/core';
import { ISiteUserInfo } from '@pnp/sp/site-users/types';
import { Router } from '@angular/router';
import { ReferenceDataService } from '../services/reference-data.service';
import { UsersService } from 'src/app/services/users.service';
import { CurrentUserService } from 'src/app/services/current-user.service';

@Component({
  selector: 'app-access-submitted',
  templateUrl: './access-submitted.component.html'
})
export class AccessRequestSubmmittedComponent  {

  user: ISiteUserInfo;

  constructor(
    private router: Router,
    private currentUserService: CurrentUserService,
    private usersService: UsersService,
    private referenceDataService: ReferenceDataService ) { }

  async ngOnInit(): Promise<void> {
    // Test if the user has an pending access request
    this.user = await this.currentUserService.get();
    if(this.user.IsAccessHubMember) {
      this.router.navigateByUrl('/');
    }
  }

}
